//--------------------------------------------------------------------------------------------------
// URLs
//--------------------------------------------------------------------------------------------------

import {
  useDeleteQuery,
  useGetQuery,
  usePatchQuery,
  usePostQuery,
  useRouteParams
} from "@quortex/front-common"
import type { DeepPartial } from "react-hook-form"
import type { QoEParams } from "@/queries/types"

/** @returns /workspaces/${workspaceUuid}/qoe_provider/?org=${orgUuid} */
const getQoEProviderConfigUrl = ({ orgUuid, workspaceUuid }: Required<QoEParams>) =>
  `/workspaces/${workspaceUuid}/qoe_provider/?org=${orgUuid}`

//--------------------------------------------------------------------------------------------------
// Queries & mutations
//--------------------------------------------------------------------------------------------------

export const useQoEProviderConfig = (params?: QoEParams) => {
  const mergedParams = useRouteParams(params)
  const url = getQoEProviderConfigUrl(mergedParams)

  return useGetQuery<api.switchns.QoeProvider>("switch", url)
}

export const useUpdateQoeProviderConfig = (params?: QoEParams) => {
  const mergedParams = useRouteParams(params)
  const url = getQoEProviderConfigUrl(mergedParams)

  type TRequest = DeepPartial<api.switchns.QoeProviderUpdate>
  type TResponse = api.switchns.QoeProvider

  return usePatchQuery<TRequest, TResponse>("switch", url, [url])
}

export const useDeleteQoEProviderConfig = (params?: QoEParams) => {
  const mergedParams = useRouteParams(params)
  const url = getQoEProviderConfigUrl(mergedParams)

  return useDeleteQuery("switch", url, [url])
}

export const useCreateQoEProviderConfig = (params?: QoEParams) => {
  const mergedParams = useRouteParams(params)
  const url = getQoEProviderConfigUrl(mergedParams)

  type TRequest = api.switchns.QoeProviderRequest
  type TResponse = api.switchns.QoeProvider & { uuid: never }

  return usePostQuery<TRequest, TResponse>("switch", url, [url])
}

export const useUpdateQoEProviderConfig = (params?: QoEParams) => {
  const mergedParams = useRouteParams(params)
  const url = getQoEProviderConfigUrl(mergedParams)

  type TRequest = api.switchns.QoeProviderRequest
  type TResponse = api.switchns.QoeProvider & { uuid: never }

  return usePatchQuery<TRequest, TResponse>("switch", url, [url])
}
